<script lang="ts">
  export let href: string
  export let text: string
</script>

<a {href} target="_blank" rel="noopener" data-text={text}>{text}</a>

<style>
  @keyframes glitch-anim-3 {
    0% {
      clip-path: inset(20% 0 41% 0);
    }
    20% {
      clip-path: inset(72% 0 9% 0);
    }
    40% {
      clip-path: inset(33% 0 64% 0);
    }
    60% {
      clip-path: inset(25% 0 58% 0);
    }
    80% {
      clip-path: inset(14% 0 71% 0);
    }
    100% {
      clip-path: inset(43% 0 58% 0);
    }
  }
  @keyframes glitch-anim-4 {
    0% {
      clip-path: inset(12% 0 20% 0);
    }
    20% {
      clip-path: inset(45% 0 86% 0);
    }
    40% {
      clip-path: inset(43% 0 9% 0);
    }
    60% {
      clip-path: inset(98% 0 24% 0);
    }
    80% {
      clip-path: inset(57% 0 54% 0);
    }
    100% {
      clip-path: inset(36% 0 1% 0);
    }
  }
  a {
    display: inline-block;
    position: relative;
    font-weight: 400;
    text-decoration: none;
    text-transform: uppercase;
    color: var(--color-callout);
  }
  a::before,
  a::after {
    content: attr(data-text);
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background: var(--color-background);
  }
  a:hover::before {
    left: -0.2rem;
    text-shadow: -0.2rem 0 var(--primary-color);
    animation: glitch-anim-3 2s infinite linear alternate-reverse;
  }
  a:hover::after {
    left: 0.2rem;
    text-shadow: -0.1rem 0 var(--tertiary-color);
    animation: glitch-anim-4 3s infinite linear alternate-reverse;
  }
  @media screen and (prefers-reduced-motion: reduce) {
    a:hover {
      color: var(--primary-color);
    }
    a:hover::after,
    a:hover::before {
      text-shadow: none;
    }
  }
</style>
